import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { UpdateHeightContext } from 'common/changelog/widget/ChangelogWidgetContainer';
import withContexts from 'common/util/withContexts';

import ChangelogWidgetEntryListItem from './ChangelogWidgetEntryListItem';

import 'css/components/changelog/widget/_ChangelogWidgetHome.scss';

class ChangelogWidgetHome extends Component {
  static propTypes = {
    entries: PropTypes.array,
    readIDs: PropTypes.array,
    updateHeight: PropTypes.func,
  };

  componentDidMount() {
    this.props.updateHeight();
  }

  render() {
    const { entries, readIDs } = this.props;
    const items = entries.map((entry) => {
      const entryIsUnread = !readIDs || !readIDs.includes(entry._id);
      return <ChangelogWidgetEntryListItem entry={entry} key={entry._id} unread={entryIsUnread} />;
    });

    return (
      <div className="changelogWidgetHome">
        <div className="entryList">{items}</div>
      </div>
    );
  }
}

export default withContexts({ updateHeight: UpdateHeightContext })(ChangelogWidgetHome);
